export function showFullScreenImage(url, width) {
    if (!url && !width) {
        document.querySelector('.modal-image .modal__main picture').remove();
        return
    }

    const img = document.createElement('img'),
        pic = document.createElement('picture');

    img.src = url;
    img.width = width

    pic.append(img)

    document.querySelector('.modal-image .modal__main').append(pic);
}
